"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.finalize = finalize;
/**
 * Finalizes a draft document = flips `status` from draft to active.
 *
 * The `id` (a permanent ULID assigned at creation) and the filename (a human slug
 * assigned at creation, e.g. `payment-design.md` or `{thread}-idea.md`) are both
 * left untouched. Finalize used to re-mint the id from the title — that destroyed a
 * perfectly good permanent ULID, broke the threaded filename convention, and could
 * produce double-suffix ids; identity must never be re-derived from a mutable title.
 */
async function finalize(input, deps) {
    const loomRoot = deps.getActiveLoomRoot();
    const docPath = await deps.findDocumentById(loomRoot, input.tempId);
    if (!docPath) {
        throw new Error(`Document with ID '${input.tempId}' not found.`);
    }
    const doc = await deps.loadDoc(docPath);
    if (doc.status !== 'draft') {
        throw new Error(`Only draft documents can be finalized. Current status: ${doc.status}`);
    }
    // Finalize is a pure status transition (draft -> active): no content change, so
    // it touches neither version nor `updated` (see loom/refs/staleness-reference.md).
    const updatedDoc = {
        ...doc,
        status: 'active',
    };
    await deps.saveDoc(updatedDoc, docPath);
    return { id: doc.id, newPath: docPath };
}
